import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.mixin({
  data: function () {
    return {
      get baseURL () {
        const fallback = process.env.NODE_ENV === 'production' ? 'https://fantasticomotors.com/' : 'http://localhost:8080/'
        const configured = process.env.VUE_APP_SITE_URL || fallback
        return configured.endsWith('/') ? configured : configured + '/'
      },
      get imageBaseURL () {
        // Images are served from the backend
        const fallback = process.env.NODE_ENV === 'production'
          ? 'https://api.fantasticomotors.com/'
          : 'http://localhost:3000/'
        const configured = process.env.VUE_APP_IMAGE_BASE_URL || fallback
        return configured.endsWith('/') ? configured : configured + '/'
      }
    }
  },
  mounted () {
    console.log('Were mixed in!!')
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
